export default __webpack_public_path__ + "static/media/DSC_7475.a1b82ade.jpg";